@if (permission()) {
<div class="security" [formArray]="permissionArray!">
    @for (key of keys; track key; let i = $index) {
    <mat-card class="row">
        <mat-card-content>
            <app-label [formGroup]="$any(permissionArray!.at(i))" [model]="key" [meta]="metaName"></app-label>
            <app-role-picker [formGroup]="$any(permissionArray!.at(i))" [meta]="metaRoles" [model]="$any(permission())[key]" groupBy="parent.name" [readonly]="readonly()">
            </app-role-picker>
        </mat-card-content>
    </mat-card>
    }
</div>
}
